import PropTypes from 'prop-types'
import React from 'react'
import Button from 'common/components/Button'
import Icon from 'common/components/Icon'
import Text from 'common/components/Text'

export const EditControls = ({
  uploadFilesToQueue,
  queueLength,
  placementMode,
  togglePlacementMode,
  switchToggle,
  t,
  Shortcuts
}) => (
  <>
    <Shortcuts/>
    <Button onClick={() => switchToggle('queue')}>
      {t('toolbar.edit.toggleQueue', { length: queueLength })}
    </Button>

    <Button as="label" htmlFor="upload">
      <Icon icon="plus" />
      <Text>{t('toolbar.edit.upload')}</Text>
    </Button>
    <input
      type="file"
      id="upload"
      multiple
      accept="image/*"
      style={{ display: 'none' }}
      onChange={e => uploadFilesToQueue(e)}
    />

    <Button
      active={placementMode === 'color'}
      onClick={() => togglePlacementMode('color')}
    >
      <Icon icon="plus" />
      <Text>{t('toolbar.edit.colorBlock')}</Text>
    </Button>

    <Button
      active={placementMode === 'text'}
      onClick={() => togglePlacementMode('text')}
    >
      <Icon icon="plus" />
      <Text>{t('toolbar.edit.textBlock')}</Text>
    </Button>
  </>
)

EditControls.propTypes = {
  board: PropTypes.object.isRequired,
  queueLength: PropTypes.number.isRequired,
  uploadFilesToQueue: PropTypes.func.isRequired,
  placementMode: PropTypes.string,
  togglePlacementMode: PropTypes.func.isRequired,
  switchToggle: PropTypes.func.isRequired
}

export default EditControls
